import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
return originalPush.call(this, location).catch(err => err)

}


export default new Router({
  // 指定该钩子函数，返回坐标值即可
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "home"
          }
        },
        {
          path: "/product1",
          name: "product1",
          component: resolve => require(["@/view/product1"], resolve),
          meta: {
            title: "product1"
          }
        },
        {
          path: "/product2",
          name: "product2",
          component: resolve => require(["@/view/product2"], resolve),
          meta: {
            title: "product2"
          }
        },
        {
          path: "/solution1",
          name: "solution1",
          component: resolve => require(["@/view/solution1"], resolve),
          meta: {
            title: "solution1"
          }
        },
        {
          path: "/solution2",
          name: "solution2",
          component: resolve => require(["@/view/solution2"], resolve),
          meta: {
            title: "solution2"
          }
        },
        {
          path: "/solution3",
          name: "solution3",
          component: resolve => require(["@/view/solution3"], resolve),
          meta: {
            title: "solution3"
          }
        },
        {
          path: "/aboutus",
          name: "aboutus",
          component: resolve => require(["@/view/aboutus"], resolve),
          meta: {
            title: "aboutus"
          }
        },
        {
          path: "/emu",
          name: "emu",
          component: resolve => require(["@/view/emu"], resolve),
          meta: {
            title: "emu"
          }
        },
        {
          path: "/events",
          name: "events",
          component: resolve => require(["@/view/events"], resolve),
          meta: {
            title: "events"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js